import React, { useState } from 'react';
import Pagination from '../../../common/Pagination';
import { useTranslation } from 'react-i18next';

const BookingsTable = ({
  bookings,
  apartments,
  guests = {},
  onUpdate,
  onDelete,
  showGuestColumn = false,
  error
}) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 5;

  // Define BookingRow inside to access the t function
  const BookingRow = ({ booking, apartments, guests, showGuestColumn, onUpdate, onDelete }) => (
    <tr className="hover:bg-gray-50 text-center">
      {showGuestColumn && (
        <td className="py-3 px-4 border-b">
          {guests[booking.guest_id] || t("unknown_guest")}
        </td>
      )}
      <td className="py-3 px-4 border-b">
        {apartments[booking.apartment] || t("unknown_apartment")}
      </td>
      <td className="py-3 px-4 border-b">{booking.start_date}</td>
      <td className="py-3 px-4 border-b">{booking.end_date}</td>
      <td className="py-3 px-4 border-b flex justify-center space-x-2">
        <button
          onClick={() => onUpdate(booking)}
          className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-700"
        >
          {t("update")}
        </button>
        <button
          onClick={() => onDelete(booking.id)}
          className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
        >
          {t("delete")}
        </button>
      </td>
    </tr>
  );

  if (error) {
    return <p className="text-red-600 font-semibold mb-4">{error}</p>;
  }

  if (bookings.length === 0) {
    return <p className="text-red-600 font-semibold mb-4">{t("no_bookings_found")}</p>;
  }

  return (
    <div className="w-full max-w-4xl overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-gray-100 text-center">
            {showGuestColumn && <th className="py-3 px-4 border-b">{t("guest_name")}</th>}
            <th className="py-3 px-4 border-b">{t("apartment_name")}</th>
            <th className="py-3 px-4 border-b">{t("start_date")}</th>
            <th className="py-3 px-4 border-b">{t("end_date")}</th>
            <th className="py-3 px-4 border-b">{t("actions")}</th>
          </tr>
        </thead>
        <tbody>
          {bookings.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE).map((booking) => (
            <BookingRow
              key={booking.id}
              booking={booking}
              apartments={apartments}
              guests={guests}
              showGuestColumn={showGuestColumn}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
      <Pagination totalItems={bookings.length} pageSize={PAGE_SIZE} currentPage={currentPage} onPageChange={setCurrentPage} />
    </div>
  );
};

export default BookingsTable;